import getArticleAndAnnotationsData from "@/view/utils/getArticleAndAnnotationsData";
import getReadAloudContentDetails from "../getReadAloudContentDetails";
import splitProseMirrorTreeIntoChunks from "../splitProseMirrorTreeIntoChunks";

const getTextChunks = (content, selectedLevel, text) => {
  const rawText = selectedLevel?.raw_text;
  if (text) {
    if (text?.type === "doc") {
      return splitProseMirrorTreeIntoChunks(text, true);
    } else {
      return [{ text }];
    }
  }

  if (!rawText) return [];

  const contentDetailChunks = getReadAloudContentDetails(
    content,
    selectedLevel,
  );

  const articleData = getArticleAndAnnotationsData({
    annotations: [],
    rawText,
    removePowerWords: true,
  });
  const articleBodyChunks = splitProseMirrorTreeIntoChunks(articleData, false);

  return [...contentDetailChunks, ...articleBodyChunks];
};

export default getTextChunks;
